/*
 * GENERATED by scripts/gen-dentacares-icons.mjs from
 * src/assets/dentacares-icons/*.svg. Do not edit by hand: edit the SVG and
 * run `pnpm icons:gen`.
 */
import type { ReactNode, SVGProps } from 'react';

export type DcIconProps = Omit<SVGProps<SVGSVGElement>, 'children'>;

/** The accent strokes, a step lighter than the base in the same colour. */
const ACCENT = 0.6;

function DcSvg({ children, ...props }: DcIconProps & { children: ReactNode }) {
  return (
    <svg
      viewBox="3 3 58 58"
      fill="none"
      stroke="currentColor"
      strokeWidth={4.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      aria-hidden
      {...props}
    >
      {children}
    </svg>
  );
}

/** `accounts.svg` */
export function DcAccountsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="5" y="6" width="12.5" height="11" rx="2" />
      <path d="M8 10h9.5" />
      <path d="M8 13.5h4.5" />
      <path d="M15.5 8.5h3.5v9a2 2 0 0 1-2 2H8" />
    </DcSvg>
  );
}

/** `appointment-list.svg` */
export function DcAppointmentListIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="5" y="6" width="4" height="4" rx="0.8" />
      <rect x="5" y="14" width="4" height="4" rx="0.8" />
      <path d="M12 8h7" />
      <path d="M12 16h7" />
      <path d="M12 11h5" />
      <path d="M12 19h5" />
    </DcSvg>
  );
}

/** `appointment-requests.svg` */
export function DcAppointmentRequestsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <circle cx="12" cy="12" r="7.5" />
      <path d="M12 8.5v4l2.8 1.8" />
    </DcSvg>
  );
}

/** `appointments.svg` */
export function DcAppointmentsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="10" y="15" width="44" height="40" rx="5" />
      <path d="M10 26 H54 M21 9 V20 M43 9 V20" />
      <path d="M22 39 L29 46 L43 32" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `balance-sheet.svg` */
export function DcBalanceSheetIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4.5 9h15" />
      <path d="M12 6v10.5" />
      <path d="M7.5 9l-2 2 2 2" />
      <path d="M16.5 9l2 2-2 2" />
      <path d="M6 18h12" />
    </DcSvg>
  );
}

/** `batches.svg` */
export function DcBatchesIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M12 4.5l7 3.5-7 3.5-7-3.5 7-3.5z" />
      <path d="M5 12l7 3.5 7-3.5" />
      <path d="M5 16l7 3.5 7-3.5" />
    </DcSvg>
  );
}

/** `branches-currencies.svg` */
export function DcBranchesCurrenciesIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M9 47 V24 H27 V47 M14 24 V16 H22 V24 M27 47 V13 H45 V47 M31 20 H41 M31 27 H41 M31 34 H41 M12 31 H23 M12 38 H23 M7 47 H47" />
      <circle cx="48" cy="45" r="11" strokeOpacity={ACCENT} />
      <path
        d="M48 38 V52 M52 40 Q44 36 44 43 Q44 46 48 46 Q53 46 52 50 Q50 53 44 50"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `branches-side-by-side.svg` */
export function DcBranchesSideBySideIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="10" width="5" height="8.5" rx="1" />
      <rect x="10.8" y="6.5" width="8.7" height="12" rx="1.2" />
      <path d="M6.8 12.7h.01" />
      <path d="M6.8 15.2h.01" />
      <path d="M13.2 9.2h.01" />
      <path d="M16 9.2h.01" />
      <path d="M13.2 12h.01" />
      <path d="M16 12h.01" />
      <path d="M13.2 14.8h.01" />
      <path d="M16 14.8h.01" />
      <path d="M13.6 18.5v-2.8c0-.5.4-.9.9-.9h1.3c.5 0 .9.4.9.9v2.8" />
    </DcSvg>
  );
}

/** `calendar.svg` */
export function DcCalendarIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="6" width="15" height="13.5" rx="2" />
      <path d="M8 4.5v3" />
      <path d="M16 4.5v3" />
      <path d="M4.5 10h15" />
      <path d="M8 13.5h3" />
      <path d="M13 13.5h3" />
      <path d="M8 16.5h3" />
    </DcSvg>
  );
}

/** `cash-control.svg` */
export function DcCashControlIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="8" width="15" height="8.5" rx="2" />
      <path d="M8 12.25h4" />
      <path d="M6.5 10.5h0" />
      <circle cx="16.5" cy="12.25" r="2" />
    </DcSvg>
  );
}

/** `cash-flow.svg` */
export function DcCashFlowIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="8" width="15" height="8.5" rx="2" />
      <path d="M8 12.25h8" />
      <path d="M6.5 10.5h0" />
      <path d="M17.5 14h0" />
      <path d="M12 5v-1.5" />
      <path d="M9.5 5.5L12 3l2.5 2.5" />
    </DcSvg>
  );
}

/** `category-at-chair.svg` */
export function DcCategoryAtChairIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M11 38 L20 29 L38 40 L33 47 H18 L11 53 M14 53 H47 M44 25 H55 M50 25 V36 M26 18 H43 L49 25 M30 18 V11 H45" />
      <path d="M47 15 L44 20 M51 18 L50 23" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `category-clinic.svg` */
export function DcCategoryClinicIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M12 55 V24 H52 V55 M9 55 H55 M25 55 V43 H39 V55 M20 33 H25 M39 33 H44" />
      <rect x="24" y="9" width="16" height="15" rx="3" strokeOpacity={ACCENT} />
      <path d="M32 12 V21 M28 17 H36" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `category-front-desk.svg` */
export function DcCategoryFrontDeskIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <circle cx="32" cy="14" r="7" />
      <path d="M19 34 V29 Q19 22 32 22 Q45 22 45 29 V34 M10 34 H54 V49 H10 Z M6 49 H58 M15 49 V55 M49 49 V55" />
    </DcSvg>
  );
}

/** `category-money.svg` */
export function DcCategoryMoneyIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M11 24 C11 18 20 14 32 14 C44 14 53 18 53 24 C53 30 44 34 32 34 C20 34 11 30 11 24 Z M11 24 V34 C11 40 20 44 32 44 C44 44 53 40 53 34 V24" />
      <circle cx="42" cy="43" r="12" strokeOpacity={ACCENT} />
      <path
        d="M42 36 V50 M47 39 C40 34 37 42 42 43 C48 44 47 50 37 48"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `chat.svg` */
export function DcChatIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M6.5 6h11A2.5 2.5 0 0 1 20 8.5v6A2.5 2.5 0 0 1 17.5 17H11l-4.5 3v-3H6.5A2.5 2.5 0 0 1 4 14.5v-6A2.5 2.5 0 0 1 6.5 6z" />
      <path d="M8.5 11h.01" />
      <path d="M12 11h.01" />
      <path d="M15.5 11h.01" />
    </DcSvg>
  );
}

/** `claims.svg` */
export function DcClaimsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5z" />
      <path d="M14 4.5V9h4" />
      <path d="M9 12h5" />
      <path d="M9 15h6" />
    </DcSvg>
  );
}

/** `clinic-web-page.svg` */
export function DcClinicWebPageIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M12 13 H52 Q56 13 56 17 V45 H8 V17 Q8 13 12 13 Z M5 51 H59 M26 45 L23 51 M38 45 L41 51" />
      <path
        d="M28 22 C24 20 22 24 23 29 L27 38 Q29 40 30 35 Q32 31 34 35 Q36 40 38 38 L42 29 Q44 24 40 22 C37 21 35 24 32 24 C30 24 29 22 28 22 Z"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `companies-plans.svg` */
export function DcCompaniesPlansIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="10" width="5" height="8.5" rx="1" />
      <rect x="10.8" y="6.5" width="8.7" height="12" rx="1.2" />
      <path d="M6.8 12.7h.01" />
      <path d="M6.8 15.2h.01" />
      <path d="M13.2 9.2h.01" />
      <path d="M16 9.2h.01" />
      <path d="M13.2 12h.01" />
      <path d="M16 12h.01" />
      <path d="M13.2 14.8h.01" />
      <path d="M16 14.8h.01" />
      <path d="M13.6 18.5v-2.8c0-.5.4-.9.9-.9h1.3c.5 0 .9.4.9.9v2.8" />
    </DcSvg>
  );
}

/** `consent-forms.svg` */
export function DcConsentFormsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M18 8 H39 L48 17 V36 M39 8 V17 H48 M43 54 H18 Q14 54 14 50 V12 Q14 8 18 8" />
      <path
        d="M22 25 H39 M22 32 H34 M21 44 Q25 37 28 44 Q30 47 34 41"
        strokeOpacity={ACCENT}
      />
      <path
        d="M42 45 L51 36 Q54 33 57 36 Q60 39 57 42 L48 51 L40 54 Z"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `data-import.svg` */
export function DcDataImportIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M12 40 V49 Q12 54 17 54 H47 Q52 54 52 49 V40" />
      <path d="M32 44 V11 M21 23 L32 11 L43 23" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `dental-chart.svg` */
export function DcDentalChartIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M22 10 C12 7 8 15 10 25 C12 34 16 48 21 51 C24 53 25 46 28 40 C30 36 34 36 36 40 C39 46 40 53 43 51 C48 48 52 34 54 25 C56 15 52 7 42 10 C38 11 35 13 32 13 C29 13 26 11 22 10 Z" />
      <path d="M20 35 L27 29 L34 34 L44 23" strokeOpacity={ACCENT} />
      <circle cx="20" cy="35" r="2" strokeOpacity={ACCENT} />
      <circle cx="27" cy="29" r="2" strokeOpacity={ACCENT} />
      <circle cx="34" cy="34" r="2" strokeOpacity={ACCENT} />
      <circle cx="44" cy="23" r="2" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `equipment-assets.svg` */
export function DcEquipmentAssetsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M12 4.7l2.2 3.5 4-.2-2 3.4 2 3.4-4-.2L12 18.1l-2.2-3.5-4 .2 2-3.4-2-3.4 4 .2L12 4.7z" />
      <circle cx="12" cy="11.4" r="1.9" />
    </DcSvg>
  );
}

/** `expense.svg` */
export function DcExpenseIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 14.5v3.25A2.25 2.25 0 0 0 6.25 20h11.5A2.25 2.25 0 0 0 20 17.75V14.5" />
      <path d="M4 15h4l1.25 2h5.5L16 15h4" />
      <path d="M12 13V4" />
      <path d="m8.5 7.5 3.5-3.5 3.5 3.5" />
    </DcSvg>
  );
}

/** `finance-accounts.svg` */
export function DcFinanceAccountsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M14 16 H48 Q53 16 53 22 V47 Q53 52 48 52 H14 Q10 52 10 48 V20 Q10 16 14 16 Z M10 24 H53" />
      <rect
        x="35"
        y="31"
        width="22"
        height="13"
        rx="4"
        strokeOpacity={ACCENT}
      />
      <circle cx="43" cy="37" r="2" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `finance-overview.svg` */
export function DcFinanceOverviewIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 19.5h16" />
      <path d="M7 16V9" />
      <path d="M12 16V5.5" />
      <path d="M17 16v-7" />
      <path d="M4 5.5v10.5" />
    </DcSvg>
  );
}

/** `income.svg` */
export function DcIncomeIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 14.5v3.25A2.25 2.25 0 0 0 6.25 20h11.5A2.25 2.25 0 0 0 20 17.75V14.5" />
      <path d="M4 15h4l1.25 2h5.5L16 15h4" />
      <path d="M12 4v9" />
      <path d="m8.5 9.5 3.5 3.5 3.5-3.5" />
    </DcSvg>
  );
}

/** `instalments.svg` */
export function DcInstalmentsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="6" width="11" height="12.5" rx="2" />
      <path d="M8 4.5v3" />
      <path d="M12 4.5v3" />
      <path d="M4.5 10.5h11" />
      <path d="M19 15.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
      <path d="M15.5 13.8v1.9l1.3.8" />
    </DcSvg>
  );
}

/** `insurance-claims.svg` */
export function DcInsuranceClaimsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M32 7 L51 15 V30 Q51 44 32 55 Q13 44 13 30 V15 Z" />
      <path d="M32 20 V42 M21 31 H43" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `insurance-overview.svg` */
export function DcInsuranceOverviewIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 19.5h16" />
      <path d="M7 16V9" />
      <path d="M12 16V5.5" />
      <path d="M17 16v-7" />
      <path d="M4 5.5v10.5" />
      <path d="M19.5 5.5l-1.2 1.2" />
    </DcSvg>
  );
}

/** `inventory.svg` */
export function DcInventoryIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M32 7 L53 18 V46 L32 57 L11 46 V18 Z M11 18 L32 29 L53 18 M32 29 V57" />
      <path d="M21 12 L43 24" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `invoices-payments.svg` */
export function DcInvoicesPaymentsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M17 8 H47 V54 L42 51 L37 54 L32 51 L27 54 L22 51 L17 54 Z" />
      <path d="M24 18 H40 M24 25 H37 M24 32 H33" />
      <circle cx="42" cy="40" r="7" strokeOpacity={ACCENT} />
      <path
        d="M42 35 V45 M45 37 C39 34 38 40 42 40 C47 40 46 45 39 43"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `lab-partner.svg` */
export function DcLabPartnerIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7.5 7V5.8A1.8 1.8 0 0 1 9.3 4h5.4a1.8 1.8 0 0 1 1.8 1.8V7" />
      <path d="M6 7h12" />
      <path d="M8 7v3.2l-2.8 5.1A2 2 0 0 0 7 18.3h10a2 2 0 0 0 1.8-3l-2.8-5.1V7" />
      <path d="M10.2 14.5l1.3 1.3 2.8-2.8" />
    </DcSvg>
  );
}

/** `lab-requests.svg` */
export function DcLabRequestsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5z" />
      <path d="M14 4.5V9h4" />
      <path d="M9.5 12h5" />
      <path d="M9.5 15h3.5" />
      <path d="M17.8 15.8l1.7 1.7" />
      <path d="M19.5 15.8l-1.7 1.7" />
    </DcSvg>
  );
}

/** `lab-tracking.svg` */
export function DcLabTrackingIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M25 9 H39 M28 9 V26 L17 46 Q13 53 21 54 H43 Q51 53 47 46 L36 26 V9" />
      <path d="M21 42 H43" strokeOpacity={ACCENT} />
      <circle cx="29" cy="47" r="2" strokeOpacity={ACCENT} />
      <circle cx="35" cy="38" r="2" strokeOpacity={ACCENT} />
      <circle cx="39" cy="48" r="1.5" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `loyalty-offers.svg` */
export function DcLoyaltyOffersIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="9" y="28" width="32" height="25" rx="3" />
      <path d="M7 28 H44 V22 H7 Z M25 22 V53" />
      <path d="M25 22 C12 22 11 9 18 10 Q25 10 25 22 C25 9 38 7 38 14 Q38 22 25 22" />
      <path d="M38 37 L51 32 L59 40 L50 56 L37 48 Z" strokeOpacity={ACCENT} />
      <circle cx="48" cy="40" r="2" strokeOpacity={ACCENT} />
      <circle cx="47" cy="49" r="2" strokeOpacity={ACCENT} />
      <path d="M46 51 L51 39" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `medical-history-qr.svg` */
export function DcMedicalHistoryQrIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M11 22 V12 H21 M43 12 H53 V22 M11 42 V52 H21 M43 52 H53 V42" />
      <rect x="20" y="17" width="9" height="9" rx="1" strokeOpacity={ACCENT} />
      <rect x="35" y="17" width="9" height="9" rx="1" strokeOpacity={ACCENT} />
      <rect x="20" y="33" width="9" height="9" rx="1" strokeOpacity={ACCENT} />
      <path
        d="M36 34 H42 V40 H48 M36 45 H42 M48 33 V36"
        strokeOpacity={ACCENT}
      />
      <path d="M28 47 C30 44 34 44 36 47" />
    </DcSvg>
  );
}

/** `money-owed-to-you.svg` */
export function DcMoneyOwedToYouIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="6.5" width="11" height="9.5" rx="2" />
      <path d="M7.5 10.5h5" />
      <path d="M18.5 9.5v7a2 2 0 0 1-2 2H8" />
      <path d="M16.5 6.5l3 3" />
      <path d="M19.5 6.5h-3v3" />
    </DcSvg>
  );
}

/** `monthly-financial-report.svg` */
export function DcMonthlyFinancialReportIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="4.5" y="6" width="15" height="13.5" rx="2" />
      <path d="M8 4.5v3" />
      <path d="M16 4.5v3" />
      <path d="M4.5 10h15" />
      <path d="M8 14v2.5" />
      <path d="M12 12v4.5" />
      <path d="M16 13.5v3" />
    </DcSvg>
  );
}

/** `offers-loyalty.svg` */
export function DcOffersLoyaltyIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M12 20l-6.5-6.5V6.8A1.8 1.8 0 0 1 7.3 5h6.7L20 11l-8 9z" />
      <circle cx="9" cy="9" r="1.2" />
    </DcSvg>
  );
}

/** `online-booking.svg` */
export function DcOnlineBookingIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="18" y="7" width="28" height="50" rx="6" />
      <path d="M26 13 H38 M29 51 H35" />
      <rect
        x="24"
        y="24"
        width="16"
        height="19"
        rx="3"
        strokeOpacity={ACCENT}
      />
      <path
        d="M27 24 V20 M37 24 V20 M27 33 L31 37 L38 29"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `overview.svg` */
export function DcOverviewIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="5" y="5" width="5" height="5" rx="1" />
      <rect x="14" y="5" width="5" height="5" rx="1" />
      <rect x="5" y="14" width="5" height="5" rx="1" />
      <rect x="14" y="14" width="5" height="5" rx="1" />
    </DcSvg>
  );
}

/** `owner-loans.svg` */
export function DcOwnerLoansIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 9.5h16" />
      <path d="M6.5 9.5v7.5" />
      <path d="M10 9.5v7.5" />
      <path d="M14 9.5v7.5" />
      <path d="M17.5 9.5v7.5" />
      <path d="M4.5 17h15" />
      <path d="M12 4l7 3.5H5L12 4z" />
    </DcSvg>
  );
}

/** `patient-file.svg` */
export function DcPatientFileIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M17 8 H39 L49 18 V54 H17 Q13 54 13 50 V12 Q13 8 17 8 Z" />
      <path d="M39 8 V18 H49" />
      <circle cx="31" cy="29" r="6" strokeOpacity={ACCENT} />
      <path d="M21 45 C22 36 40 36 41 45" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `patient-qr-card.svg` */
export function DcPatientQrCardIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="7" y="14" width="50" height="36" rx="5" />
      <circle cx="20" cy="27" r="5" strokeOpacity={ACCENT} />
      <path d="M11 42 C12 32 28 32 29 42" strokeOpacity={ACCENT} />
      <rect x="36" y="22" width="7" height="7" rx="1" strokeOpacity={ACCENT} />
      <rect x="47" y="22" width="5" height="5" rx="1" strokeOpacity={ACCENT} />
      <rect x="36" y="34" width="5" height="5" rx="1" strokeOpacity={ACCENT} />
      <path d="M46 33 H51 V39 M47 43 H52 M36 44 H40" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `patient-statement.svg` */
export function DcPatientStatementIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5z" />
      <path d="M14 4.5V9h4" />
      <path d="M9 12h5" />
      <path d="M9 15h6" />
      <path d="M9 18h4" />
    </DcSvg>
  );
}

/** `payroll-commission.svg` */
export function DcPayrollCommissionIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="8" y="15" width="48" height="35" rx="5" />
      <circle cx="22" cy="29" r="6" strokeOpacity={ACCENT} />
      <path d="M13 43 C13 34 31 34 31 43" strokeOpacity={ACCENT} />
      <path d="M37 25 H49 M37 32 H48 M37 39 H44" />
    </DcSvg>
  );
}

/** `prescriptions.svg` */
export function DcPrescriptionsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M19 16 L37 8 Q44 5 49 12 Q54 18 49 24 L27 51 Q21 58 14 52 Q8 46 13 39 Z" />
      <path d="M23 32 L39 44" strokeOpacity={ACCENT} />
      <path d="M34 12 L47 23" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `production-by-dentist.svg` */
export function DcProductionByDentistIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M6.5 9.5a3 3 0 1 1 6 0c0 1.7-1.3 2.8-2.2 3.7-.7.7-1.1 1.4-1.3 2.3" />
      <path d="M15.2 8.4a2.6 2.6 0 1 1 3.6 3.8c-.8.6-1.4 1.3-1.6 2.3" />
      <path d="M9 15.5v2.2a2.5 2.5 0 0 0 5 0V15.5" />
    </DcSvg>
  );
}

/** `profit-loss.svg` */
export function DcProfitLossIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M6 19h12" />
      <path d="M8 16V8.5" />
      <path d="M12 16V5.5" />
      <path d="M16 16v-4.5" />
      <path d="M7 8h10" />
      <path d="M9.5 5.5L12 3l2.5 2.5" />
      <path d="M9.5 11.5L12 14l2.5-2.5" />
    </DcSvg>
  );
}

/** `profit-per-treatment.svg` */
export function DcProfitPerTreatmentIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path
        d="M11 51 H53 M16 43 V51 M29 34 V51 M42 25 V51"
        strokeOpacity={ACCENT}
      />
      <path d="M13 30 L26 24 L36 29 L51 13 M42 13 H51 V22" />
    </DcSvg>
  );
}

/** `queue-waiting-room.svg` */
export function DcQueueWaitingRoomIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M8 44 V36 Q8 32 12 32 H20 Q24 32 24 36 V44 M27 44 V36 Q27 32 31 32 H39 Q43 32 43 36 V44 M46 44 V36 Q46 32 50 32 H54 Q58 32 58 36 V44 M9 44 H57 M12 44 V50 M54 44 V50" />
      <circle cx="33" cy="17" r="10" strokeOpacity={ACCENT} />
      <path d="M33 11 V17 L39 20" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `recalls.svg` */
export function DcRecallsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M6 16.5a6 6 0 1 1 12 0" />
      <path d="M12 7v5" />
      <path d="M5 16.5h14" />
      <path d="M8.2 18.5a3.8 3.8 0 0 0 7.6 0" />
      <path d="M18 7.5l1.5-1.5" />
      <path d="M6 7.5L4.5 6" />
    </DcSvg>
  );
}

/** `refunds-corrections.svg` */
export function DcRefundsCorrectionsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5z" />
      <path d="M14 4.5V9h4" />
      <path d="M9 13h6" />
      <path d="M11 11l-2 2 2 2" />
      <path d="M13 16l2-2-2-2" />
    </DcSvg>
  );
}

/** `reports-analytics.svg` */
export function DcReportsAnalyticsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <rect x="7" y="11" width="50" height="38" rx="4" />
      <path d="M25 49 V56 M39 49 V56 M18 56 H46" />
      <path d="M16 39 V32 M23 39 V25 M30 39 V29" strokeOpacity={ACCENT} />
      <path
        d="M43 23 A11 11 0 1 1 33 35 L43 35 Z M45 21 V32 H56 A11 11 0 0 0 45 21 Z"
        strokeOpacity={ACCENT}
      />
    </DcSvg>
  );
}

/** `reports.svg` */
export function DcReportsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 19.5h16" />
      <path d="M7 16V9" />
      <path d="M12 16V5.5" />
      <path d="M17 16v-7" />
      <path d="M4 5.5v10.5" />
      <rect x="3.8" y="17" width="16.4" height="3" rx="1" />
    </DcSvg>
  );
}

/** `team-permissions.svg` */
export function DcTeamPermissionsIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <circle cx="29" cy="20" r="8" />
      <circle cx="12" cy="26" r="5" strokeOpacity={ACCENT} />
      <circle cx="47" cy="26" r="5" strokeOpacity={ACCENT} />
      <path d="M16 48 V42 Q16 32 29 32 Q42 32 42 42 V48 M6 45 V42 Q6 35 13 35 M52 36 Q58 38 58 44" />
      <circle cx="47" cy="47" r="8" strokeOpacity={ACCENT} />
      <path d="M47 42 V52 M42 47 H52" strokeOpacity={ACCENT} />
    </DcSvg>
  );
}

/** `transactions.svg` */
export function DcTransactionsIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19V6A1.5 1.5 0 0 1 7.5 4.5z" />
      <path d="M14 4.5V9h4" />
      <path d="M9 12h5" />
      <path d="M9 15h6" />
    </DcSvg>
  );
}

/** `waitlist.svg` */
export function DcWaitlistIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <rect x="7" y="4.5" width="10" height="15" rx="1.8" />
      <path d="M10 4.5h4" />
      <path d="M10 9h4" />
      <path d="M10 12h4" />
      <path d="M10 15h2.5" />
      <path d="M5 8.8l1.2 1.2L8.7 7.5" />
    </DcSvg>
  );
}

/** `what-each-patient-spent.svg` */
export function DcWhatEachPatientSpentIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <circle cx="10" cy="9" r="2.5" />
      <path d="M5.5 18a4.8 4.8 0 0 1 9 0" />
      <circle cx="17.2" cy="15.5" r="2.3" />
      <path d="M17.2 14.2v2.6" />
      <path d="M16.2 15.5h2" />
    </DcSvg>
  );
}

/** `what-it-costs-to-run.svg` */
export function DcWhatItCostsToRunIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 8l5 5 3-3 6 7" />
      <path d="M15 17h3v-3" />
    </DcSvg>
  );
}

/** `which-treatments-make-money.svg` */
export function DcWhichTreatmentsMakeMoneyIcon(props: DcIconProps) {
  return (
    <DcSvg viewBox="0 0 24 24" strokeWidth={1.8} {...props}>
      <path d="M4 16l5-5 3 3 6-7" />
      <path d="M15 7h3v3" />
      <circle cx="8" cy="16" r="1.2" />
      <path d="M6.8 19.5h2.4" />
    </DcSvg>
  );
}

/** `x-rays-photos.svg` */
export function DcXRaysPhotosIcon(props: DcIconProps) {
  return (
    <DcSvg {...props}>
      <path d="M10 20 V13 Q10 10 14 10 H21 M43 10 H50 Q54 10 54 14 V21 M54 43 V50 Q54 54 50 54 H43 M21 54 H14 Q10 54 10 50 V43" />
      <rect
        x="19"
        y="19"
        width="26"
        height="26"
        rx="4"
        strokeOpacity={ACCENT}
      />
      <path d="M26 25 C21 24 22 34 26 40 C28 42 29 35 32 35 C35 35 36 42 38 40 C42 34 43 24 38 25 C35 26 34 27 32 27 C30 27 29 26 26 25 Z" />
    </DcSvg>
  );
}
